import constantsProd from './constants.prod'
import constantsDev from './constants.dev'
import constantsTest from './constants.Test'

let constants

if (process.env.NODE_ENV === 'production') {
  constants = constantsProd
} else if (process.env.NODE_ENV === 'test') {
  constants = constantsTest
} else {
  constants = constantsDev
}

// We now back to using CommonJS because there are codebase where it depends
// on name export and we're not doing name export anywhere
export default constants



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/config/constants.js